export default __webpack_public_path__ + "static/media/screenshot_step2_3_purple.77105fc1.png";